"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var adzerkHeaderBiddingUnitMap_1 = require("../config/adzerkHeaderBiddingUnitMap");
var getHardcodedAdsList_1 = __importDefault(require("./getHardcodedAdsList"));
/**
 * Returns a string of the HTML of a hardcoded creative
 */
function getHardcodedAdString(placement, unitMetaOverrides) {
    if (placement === void 0) { placement = "unknown"; }
    var unitMetaDefaults = {
        additionalClasses: "",
        adText: "",
        adTextClass: "",
        height: 0,
        inlineStyle: "",
        parentClass: "",
        ts: Date.now(),
        width: 0,
    };
    if (unitMetaOverrides &&
        "width" in unitMetaOverrides !== "height" in unitMetaOverrides) {
        throw new Error("Invalid height or width specification. Must have both or neither");
    }
    var unitMeta = __assign(__assign({}, unitMetaDefaults), unitMetaOverrides);
    var placementConfig = adzerkHeaderBiddingUnitMap_1.adzerkHeaderBiddingUnitMap[placement];
    if (!placementConfig) {
        throw new Error("invalid ad placement: ".concat(placement));
    }
    var hasParent = !!unitMeta.parentClass;
    var adTextTemplate = unitMeta.adText
        ? "<h4 class=\"".concat(unitMeta.adTextClass, "\">").concat(unitMeta.adText, "</h4>")
        : "";
    var adsList = (0, getHardcodedAdsList_1.default)(unitMeta.width, unitMeta.height);
    var hardcodedCreative = "";
    if (adsList.length) {
        var totalVariations = adsList.length;
        var variation = Math.floor(Math.random() * totalVariations);
        var ad = adsList[variation];
        var assetPath = "https://static.wattpad.com/image/".concat(ad.prefix); //`${assets.assetServer}/image/${ad.prefix}`;
        var creativePath = "".concat(assetPath, "_").concat(unitMeta.width, "x").concat(unitMeta.height).concat(ad.postfix, ".png"); // prettier-ignore
        hardcodedCreative = "<a href=\"".concat(ad.link, "\" class=\"hc-creative\" rel=\"nofollow\" target=\"_blank\"><img src=\"").concat(creativePath, "\" width=\"").concat(unitMeta.width, "\" height=\"").concat(unitMeta.height, "\" alt=\"\" /></a>"); // prettier-ignore
    }
    // Refreshing ads only generate creative assets, not containers
    if (!hasParent) {
        return hardcodedCreative;
    }
    // Ads from templates generate containers
    // @ts-ignore
    if (placementConfig.sticky) {
        return "<div id=\"".concat(placement, "-").concat(unitMeta.ts, "\" class=\"").concat(unitMeta.parentClass, " ").concat(unitMeta.additionalClasses, "\" data-start-selector=\"").concat(placementConfig.stickyStart, "\" data-end-selector=\"").concat(placementConfig.stickyEnd, "\" aria-label=\"Advertisement\">").concat(adTextTemplate).concat(hardcodedCreative, "</div>"); // prettier-ignore
    }
    else {
        return "<div id=\"".concat(placement, "-").concat(unitMeta.ts, "\" class=\"advertisement hc ").concat(unitMeta.parentClass, " ").concat(unitMeta.additionalClasses, "\" ").concat(unitMeta.inlineStyle, ">").concat(adTextTemplate).concat(hardcodedCreative, "</div>"); // prettier-ignore
    }
}
exports.default = getHardcodedAdString;
